import React from "react";
import { SxStyleProp } from "theme-ui";
import Box from "../Box/Box";
import { DownArrowIcon } from "../icons";
import Select, { components } from "react-select";
import { SVGProps } from "../icons/SVG";

const variants = {
  primary: {
    border: "1px solid #86B8D8",
    borderRadius: "0.25rem",
    margin: "0.5rem 0 0 0",
  },
  underline: {
    border: "none",
    borderBottom: "1px solid #ccc",
  },
};

type VariantKey = "primary" | "underline";

interface Props
  extends React.HTMLAttributes<HTMLSelectElement & HTMLDivElement> {
  sx?: SxStyleProp;
  outerSx?: SxStyleProp;
  options: Array<any>;
  isOptionDisabled?: (option: any) => boolean;
  variant?: VariantKey;
}

const DropdownIndicator: React.FunctionComponent<SVGProps> = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownArrowIcon />
    </components.DropdownIndicator>
  );
};

const SelectStyled: React.FunctionComponent<Props | any> = React.forwardRef(
  (
    {
      variant,
      sx,
      outerSx,
      options,
      isOptionDisabled,
      value,
      defaultValue,
      onChange,
      ...restProps
    },
    ref,
  ) => {
    const defaultSelectedOption = defaultValue
      ? options.find((option: any) => option.value === defaultValue)
      : "default";

    const selectValue = value
      ? options.find((option: any) => option.value === value)
      : "default";

    const customStyles = {
      control: (provided: any) => ({
        ...provided,
        background: "transparent",
        border: "none",
        borderRadius: "none",
        minHeight: "16px !important",
        // Per client, removed focus outline which is set by the `boxShadow` property
        boxShadow: "0 !important",
        padding: variant === "primary" ? "0 0.8rem" : "0",
      }),
      dropdownIndicator: (provided: any) => ({
        ...provided,
        padding: "0",
        marginRight: "-10.5px",
        color: "black",
      }),
      valueContainer: (provided: any) => ({
        ...provided,
        paddingLeft: "0",
      }),
      indicatorSeparator: () => ({ display: "none", padding: "0" }),
      placeholder: () => ({
        color: "#757575",
        fontSize: "0.9rem",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }),
    };
    return (
      <Box
        sx={{
          ...variants[variant as VariantKey],
          ...(outerSx as any),
        }}
      >
        <Select
          ref={ref}
          sx={{
            ...(sx as any),
          }}
          styles={customStyles}
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              neutral20: "#86B8D8",
            },
          })}
          options={options}
          components={{ DropdownIndicator }}
          isOptionDisabled={isOptionDisabled}
          value={selectValue}
          defaultValue={defaultSelectedOption}
          onChange={onChange}
          menuPlacement="auto"
          {...restProps}
        />
      </Box>
    );
  },
);

SelectStyled.displayName = "SelectStyled";

export default SelectStyled;
